import {InputSelect} from '@/components/commons/input-select/InputSelect'
import {ProjectFieldsSchema} from '@/features/projects/formSchemas'
import {projectCycleCountToLabel} from '@/features/projects/utils'
import {useTranslation} from '@/translations/i18n'
import {useController, useFormContext} from 'react-hook-form'
import {z} from 'zod'

const ProjectCycleCountFieldSchema = ProjectFieldsSchema.pick({
    numberOfCycles: true
})
type ProjectCycleCountFieldSchemaType = z.infer<typeof ProjectCycleCountFieldSchema>

export const ProjectCycleCountField = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<ProjectCycleCountFieldSchemaType>()
    const {field, fieldState} = useController({
        control,
        name: 'numberOfCycles'
    })
    return (
        <InputSelect
            {...field}
            value={field.value ?? undefined}
            label={t('projects:cycle_count')}
            optionsMap={projectCycleCountToLabel}
            errorMessage={fieldState.error?.message}
        />
    )
}
